module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0006#intro"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" / “To See What Is about to Be Born”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0007#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")]), _vm._v(" / The Liminal Fetus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0008#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TWO")]), _vm._v(" / Genetics, Morphology, and Difficult Diagnoses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0009#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THREE")]), _vm._v(" / Diagnostic Puzzles: Fetopathology in France")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0010#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FOUR")]), _vm._v(" / Visible Disasters: Fetopathology in Brazil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0011#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIVE")]), _vm._v(" / Balancing Risks: PND and the “Prevention of Disability”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0012#ch06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("SIX")]), _vm._v(" / PND, Reproductive Choices, and Care")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0013#conc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CONCLUSION")]), _vm._v(" / A Nonscrutinized Diagnosis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0014#ch07"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CODA")]), _vm._v(" / Minerva’s Owl and Apollo’s Lyre")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0015#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0016#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0018#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilowy0019#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd82906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lowy-0005.vue
// module id = 66
// module chunks = 0